import { z } from "zod";

// ncfz login - request
export const ncfzLoginRequestSchema = z.object({
  secondaryId: z.string().trim().nonempty({ message: "아이디를 입력해주세요." }),
  secondaryPassword: z.string().trim().nonempty({ message: "비밀번호를 입력해주세요." }),
});
export type NcfzLoginRequestType = z.infer<typeof ncfzLoginRequestSchema>;

// ncfz login - response
export const ncfzLoginSchema = z.literal("");
export type NcfzLoginType = z.infer<typeof ncfzLoginSchema>;

export const ncfzLogoutSchema = z.literal("");
export type NcfzLogoutType = z.infer<typeof ncfzLogoutSchema>;

/**
 * companyStateCode
 * PC방 stateCode
 * - 0 : 가입대기
 * - 1 : 정상
 * - 2 : 휴업
 * - 3 : 폐업
 * - 4 : 폐업(명의변경)
 * - 5 : 미등록

 * ncfzUserStatusCode
 * 사용자 상태
 * - LOGOUT_USER(로그아웃 상태)
 * - NCFZ_USER_0(계정 전환 필요 상태)
 * - NCFZ_USER_1(계정 전환 완료 상태)
 * - PLAYNC_USER_0(PC방 등록하지 않은 상태)
 * - PLAYNC_USER_1(PC방 등록 후 승인 대기 상태)
 * - PLAYNC_USER_2(PC방 등록 승인 완료)
 */

export const loginInfoRawSchema = z.object({
  ip: z.string(),
  ncfzUserInfo: z.object({
    login: z.boolean(),
    companyStateCode: z.number(),
    statusCode: z.number(),
    lastAccessedTime: z.number(),
    companyId: z.string().optional(),
    companyName: z.string().optional(),
    pccafeAccount: z.string().optional(),
    name: z.string().optional(),
    email: z.string().optional(),
    sessionId: z.string().optional(),
    digest: z.string().optional(),
  }),
  playncUserInfo: z.object({
    login: z.boolean(),
    userId: z.string().optional(),
    nickName: z.string().optional(),
    account: z.string().optional(),
    checkRealName: z.boolean().optional(),
  }),
  ncfzPlayncUserInfo: z
    .object({
      personName: z.string().optional(),
    })
    .optional(),
  ncfzUserStatusCode: z.string(),
});

export const loginInfoSchema = loginInfoRawSchema.extend({
  isLogin: z.boolean(),
  iCafeId: z.string().nullable(),
});

export type LoginInfoRawType = z.infer<typeof loginInfoRawSchema>;
export type LoginInfoType = z.infer<typeof loginInfoSchema>;

export const loginICafeInfoSchema = z.object({
  gCoin: z.number(),
  recurringStatus: z.boolean(),
  paymentType: z.number().nullable(),
  smartICafe: z.boolean(),
  smartICafeJoinable: z.boolean(),
  smartICafeRegisterDate: z.string().optional(),
});
export type LoginICafeInfoType = z.infer<typeof loginICafeInfoSchema>;
